import { render } from "./ModalCadastrarEquipe.vue?vue&type=template&id=1c4d0eae"
import script from "./ModalCadastrarEquipe.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarEquipe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__